export default "__VITE_ASSET__BW8h_nDg__"